export function criarLinkRelatorio(relatorio, nome) {
    let blob = new Blob([relatorio], { type: 'application/vnd.ms-excel' })
    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = `${nome}.xlsx`
    link.click()
}